import PropTypes from "prop-types"
import { useContext, useEffect, useRef, useState } from "react"
import { useFormContext } from "react-hook-form"
import { useHistory } from "react-router"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import useReadOnly from "~/hooks/useReadOnly"
import checkMetaKey from "~/utils/checkMetaOrCtrl"
import Snackbar from "../../Common/Snackbar"

const UnsavedChanges = ({ onSubmitHandler, isLoading }) => {
  const isReadOnly = useReadOnly()
  const { openDialog } = useContext(AppContext)

  const [openSnackbar, setOpenSnackbar] = useState(false)
  const {
    formState: { isDirty },
    reset,
  } = useFormContext()

  const blockRef = useRef()

  const history = useHistory()

  // open save snack bar if we have unsaved data
  useEffect(() => {
    if (isDirty) {
      setOpenSnackbar(true)
    } else {
      setOpenSnackbar(false)
    }
  }, [isDirty])

  // //open dialog if we go to other part of the app without save
  useEffect(() => {
    if (isDirty && !isReadOnly) {
      blockRef.current = {
        unblock: history.block((tx) => {
          openDialog("unsavedDataDialog", tx).then(() => {
            reset()
            blockRef.current.unblock()
            history.push(tx.pathname)
          })

          return false
        }),
      }
    } else {
      blockRef.current?.unblock?.()
    }
  }, [isDirty])

  useEffect(() => {
    document.onkeydown = function (e) {
      if (e.code === "KeyS" && checkMetaKey(e)) {
        e.preventDefault()
        onSubmitHandler()
      }
    }
    return () => {
      document.onkeydown = () => ""
    }
  }, [onSubmitHandler])

  return (
    <PermissionsWrapper permissionGroup="admin">
      <Snackbar
        open={openSnackbar}
        message="Unsaved Changes"
        action={onSubmitHandler}
        setOpenSnackbar={setOpenSnackbar}
        isLoading={isLoading}
        actionClassName="w-[20px]"
      />
    </PermissionsWrapper>
  )
}

UnsavedChanges.propTypes = {
  unsavedChanges: PropTypes.bool,
  setOpenSnackbar: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default UnsavedChanges
